import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-search",
  "use": "icon-search-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-search\"><defs><style type=\"text/css\"></style></defs><path d=\"M898.2380982 911.27243314L670.45031742 683.48465237a301.69830322 301.69830322 0 1 0-50.79803471 54.01153561L845.70971682 963.55362209z m-704.49829109-405.76629641a233.84399415 233.84399415 0 1 1 233.59680176 233.84399412A234.09118654 234.09118654 0 0 1 193.61621094 505.50613673z\" p-id=\"2844\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol